// extracted by mini-css-extract-plugin
module.exports = {"TreatsFormWrapper":"TreatsSelectionForm_TreatsFormWrapper__2B7fa","TreatsFormSectionWrapper":"TreatsSelectionForm_TreatsFormSectionWrapper__1ccTZ"};